import { useQuery } from '@tanstack/vue-query';
import ReferencesService from '@/services/references.service';
import { ComputedRef } from 'vue';

const useFetchTimezonesQuery = (enabled?: ComputedRef<boolean>) => {
  return useQuery(
    ['reference', 'timezones'],
    async () => {
      const { data: timezones } = await ReferencesService.getTimeZones();
      return timezones;
    },
    {
      enabled,
      initialData: [],
    }
  );
};

export default useFetchTimezonesQuery;
